import { Badge } from '@/components/ui/badge';

type BadgeTone = 'slate' | 'green' | 'red' | 'amber' | 'blue' | 'cyan' | 'violet';

type BadgeProperties = {
  value?: boolean | string | null;
};

const normalize = (value?: boolean | string | null): string => {
  if (typeof value === 'boolean') {
    return value ? 'enabled' : 'disabled';
  }
  return value || 'unknown';
};

const statusTone = (resolved: string): BadgeTone => {
  if (resolved.includes('fail') || resolved === 'disabled' || resolved === 'open') {
    return 'red';
  }
  if (resolved === 'completed' || resolved === 'enabled' || resolved === 'resolved') {
    return 'green';
  }
  if (resolved === 'acknowledged' || resolved === 'pending') {
    return 'amber';
  }
  return 'slate';
};

export const StatusBadge = ({ value }: BadgeProperties) => {
  const resolved = normalize(value).toLowerCase();

  return <Badge tone={statusTone(resolved)}>{normalize(value)}</Badge>;
};

const severityTone = (resolved: string): BadgeTone => {
  if (resolved === 'fatal' || resolved === 'error') {
    return 'red';
  }
  if (resolved === 'warning' || resolved === 'warn') {
    return 'amber';
  }
  if (resolved === 'info') {
    return 'blue';
  }
  return 'slate';
};

export const SeverityBadge = ({ value }: BadgeProperties) => {
  const resolved = normalize(value).toLowerCase();

  return <Badge tone={severityTone(resolved)}>{normalize(value)}</Badge>;
};

const environmentTone = (resolved: string): BadgeTone => {
  if (resolved === 'prod') {
    return 'red';
  }
  if (resolved === 'beta') {
    return 'amber';
  }
  if (resolved === 'dev') {
    return 'cyan';
  }
  return 'slate';
};

export const EnvironmentBadge = ({ value }: BadgeProperties) => {
  const resolved = normalize(value).toLowerCase();

  return <Badge tone={environmentTone(resolved)}>{normalize(value)}</Badge>;
};

const runtimeTone = (resolved: string): BadgeTone => {
  if (resolved === 'lambda') {
    return 'violet';
  }
  if (resolved === 'ecs') {
    return 'blue';
  }
  return 'slate';
};

export const RuntimeBadge = ({ value }: BadgeProperties) => {
  const resolved = normalize(value).toLowerCase();

  return <Badge tone={runtimeTone(resolved)}>{normalize(value)}</Badge>;
};
